/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_CreationInputs */

const en_profile_creation = /** @type {(inputs: Profile_CreationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profile creation`)
};

const de_profile_creation = /** @type {(inputs: Profile_CreationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profilerstellung`)
};

/**
* | output |
* | --- |
* | "Profile creation" |
*
* @param {Profile_CreationInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const profile_creation = /** @type {((inputs?: Profile_CreationInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_CreationInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_profile_creation(inputs)
	return en_profile_creation(inputs)
});